module.exports = __webpack_public_path__ + "assets/img/cc0965233f9c1a78504ee5fb5d95e537.png";